/* eslint-disable no-undef */
import React from 'react';
import { useSelector } from 'react-redux';
import { LinksSystemOptionStyle } from './style';

export default function LinksSystemOption({ link }) {
  const { userInfo } = useSelector((state) => state.userSign);

  return (
    <LinksSystemOptionStyle>
      <p>
        {link.name} ({link.company})
      </p>
      {userInfo.accessMode === process.env.REACT_APP_DEV_ACCESS && (
        <a href={`/editar-links-sistema/${link._id}`}>Editar</a>
      )}
      {userInfo.accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS && (
        <a href={`/editar-links-sistema/${link._id}`}>Editar</a>
      )}
    </LinksSystemOptionStyle>
  );
}
